import { render, staticRenderFns } from "./price.vue?vue&type=template&id=b53e780e&scoped=true"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"
import style0 from "./price.vue?vue&type=style&index=0&id=b53e780e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53e780e",
  null
  
)

export default component.exports